module.exports = __webpack_public_path__ + "img/Piotr_Pieprzyk_Photo2.d4711b1b.png";